import React from "react";
import { ArrowRight, Shield } from "lucide-react";
import { t } from "../../i18n/translations";
import TrustBadges from "../shared/TrustBadges";

const CTASection = () => {
  return (
    <section id="cta" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-slate-900 rounded-lg p-8 sm:p-12 lg:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/10 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-600/10 rounded-full translate-y-1/2 -translate-x-1/2" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-white/10 text-white/90 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-6 border border-white/20">
              {t("cta.badge")}
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-4">
              {t("cta.title")}
            </h2>
            <p className="text-lg text-white/70 max-w-2xl mx-auto mb-8">{t("cta.subtitle")}</p>

            <button className="group inline-flex items-center gap-2 bg-red-600 text-white font-bold text-lg px-10 py-5 rounded-lg hover:bg-red-700 transition-colors duration-150 shadow-md shadow-red-600/30">
              <Shield size={20} />
              {t("cta.button")}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>

            <TrustBadges className="mt-8 [&_div]:bg-white/10 [&_div]:text-white/80 [&_div]:border-white/10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
